/**
 * Format elapsed milliseconds as MM:SS.
 */
export function formatDuration(ms: number): string {
	const totalSeconds = Math.floor(ms / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;
	return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

/**
 * Subscribe to recording duration updates.
 * startedAt is a UTC timestamp in milliseconds (device ts * 1000).
 * Calls onUpdate with the current duration every second while startedAt is set.
 * Returns a cleanup function to stop the interval.
 */
export function subscribeRecordingDuration(
	startedAt: number | null,
	onUpdate: (duration: string) => void,
): () => void {
	if (startedAt == null) {
		onUpdate('');
		return () => {};
	}

	const updateDuration = () => {
		const elapsed = Date.now() - startedAt;
		onUpdate(elapsed > 0 ? formatDuration(elapsed) : '00:00');
	};

	updateDuration();
	const interval = setInterval(updateDuration, 1000);
	return () => clearInterval(interval);
}
